export const TEXT_ELEMENT_TAGS = [
  "p",
  "span",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
];
export const TEXT_ELEMENT_VARIANTS = [
  "display1",
  "display2",
  "title1",
  "title2",
  "title3",
  "title4",
  "body-large",
  "body",
  "body-small",
];

export const VARIANT_FONT_SIZE_MAP = {
  title1: { beginScale: 30, maxFontSize: 3.7, scale: 15, factor: -0.525 },
  title2: { beginScale: 30, maxFontSize: 2, scale: 5.58, factor: -0.315 },
  title3: { beginScale: 30, maxFontSize: 2.2, scale: 5.58, factor: -0.4 },
  title4: { beginScale: 30, maxFontSize: 2, scale: 5.58, factor: -0.45 },
  // add more variants here
};

export const VARIANT_MOBILE_FONT_SIZE_MAP = {
  title3: { beginScale: 25, maxFontSize: 2.2, scale: 8.192, factor: -0.256 },
  title4: { beginScale: 30, maxFontSize: 2.2, scale: 8.192, factor: -0.256 },
  // add more variants here
};
